import { ApiService } from "@/api";
export const getSubmitedAnswer = (sampleId: string) => {
  return ApiService.baseAction(`answer/${sampleId}`, {}, "GET");
};
